"use client"

import { type ChangeEvent } from "react"

interface SearchInputProps {
  /** Current value */
  value: string
  /** Change handler */
  onChange: (value: string) => void
  /** Placeholder text */
  placeholder?: string
  /** Additional classes on the wrapper */
  className?: string
  /** Field name (a form field needs an id or a name) */
  name?: string
}

export function SearchInput({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
  name = "q",
}: SearchInputProps) {
  return (
    <div className={`relative ${className}`}>
      <svg
        className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
      <input
        type="text"
        name={name}
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full h-10 pl-10 pr-4 text-sm text-gray-900 placeholder-gray-400 bg-white border border-gray-200/60 rounded-full outline-none focus:border-[#0469f0]/30 focus:ring-2 focus:ring-[#0469f0]/10 transition-all"
      />
    </div>
  )
}
